import { useContext, useMemo } from "react";

import { CafsContext } from "../views/cafs-view/CafsContext";
import { CafsSection } from "../views/cafs-view/const/cafs-section";

export function useAssignedReferences<T>(
  variableName: keyof T | undefined,
  productCode: string | undefined,
  sectionName: CafsSection,
) {
  const { assignedReferences } = useContext(CafsContext);

  const assignedData = useMemo(() => {
    return (assignedReferences?.ReferencesTo || []).filter(r => {
      const fieldMatch =
        r.FieldName === `${sectionName}.${variableName as string}`;

      if (!fieldMatch) return false;

      return productCode === undefined || r.PlantProductCode === productCode;
    });
  }, [variableName, assignedReferences, sectionName, productCode]);

  const inheritedData = useMemo(() => {
    return (assignedReferences?.ReferencesForParents || []).filter(r => {
      const fieldMatch =
        r.FieldName === `${sectionName}.${variableName as string}`;

      if (!fieldMatch) return false;

      return productCode === undefined || r.PlantProductCode === productCode;
    });
  }, [variableName, assignedReferences, sectionName, productCode]);

  return {
    assignedReferences: assignedData,
    inheritedReferences: inheritedData,
  };
}
